/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
`;

export const CompanyContainer = styled.div`
  margin-left: 20px;
  width: 95%;
`;
export const CompanyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  width: 100%;
  background-color: #fff;
  height: 80vh;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 25px;
`;
